
<ng-container *ngIf="isLoaded">
  <div class="bank-selector-container">
    <div class="row g-2 align-items-end">
      <div class="col-md-9 col-12">
        <label class="form-label">Към Бюджетна Сметка</label>
        <select [(ngModel)]="selectedBankAccount" (change)="onBankAccountChange($event)" class="form-select">
          <option [ngValue]="null" disabled>Изберете банкова сметка</option>
          <option *ngFor="let option of bankAccounts" class="big-option" [ngValue]="option.idBankDetails">
            {{ option.title }} ({{ option.iban }})
          </option>
        </select>
      </div>
      <div class="col-md-3 col-12">
        <button type="button" class="btn btn-primary w-100"
                (click)="createBankAccount()">
          Създай Сметка
        </button>
      </div>
    </div>
  </div>

</ng-container>
<ng-container *ngIf="!isLoaded">
  <div style="text-align: center;">
    <div class="spinner-grow spinner-grow-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

</ng-container>
